import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { components } from 'react-select';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

const CustomOptionWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const FadeOutWrapper = styled('div')`
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .fade-out {
    animation: fadeOut 1.5s ease-out forwards;
  }
`;

export const CustomMultiValue = (props) => {
  const { data, selectProps } = props;
  const fadingUsers = selectProps.fadingUsers || [];
  const isFading = fadingUsers.includes(data.id);

  return (
    <FadeOutWrapper>
      <div className={isFading ? 'fade-out' : ''}>
        <components.MultiValue {...props} />
      </div>
    </FadeOutWrapper>
  );
};

CustomMultiValue.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  selectProps: PropTypes.shape({
    fadingUsers: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
};

// Custom option component for react-select for styling purposes
export const CustomOption = (props) => {
  const { data, selectProps } = props;
  const {
    selectedGroups = [],
    isUserInSelectedGroups,
  } = selectProps;

  const isDisabled = isUserInSelectedGroups
    ? isUserInSelectedGroups(data, selectedGroups)
    : false;

  return (
    <components.Option {...props}>
      <CustomOptionWrapper>
        <span>{`${data.first} ${data.last}`}</span>
        {isDisabled && (
          <IcomoonReact
            iconSet={iconSet}
            size={16}
            icon='checkmark'
            color='#444444'
          />
        )}
      </CustomOptionWrapper>
    </components.Option>
  );
};

CustomOption.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    first: PropTypes.string,
    last: PropTypes.string,
  }).isRequired,
  selectProps: PropTypes.shape({
    selectedGroups: PropTypes.arrayOf(PropTypes.number),
    isUserInSelectedGroups: PropTypes.func,
  }).isRequired,
};

export const customSelectStyles = {
  option: (provided, state) => ({
    ...provided,
    ...(state.isDisabled
      ? { color: '#999', opacity: 0.6 }
      : {}),
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: '100px',
    overflowY: 'auto',
    padding: '2px 8px',
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '38px',
    maxHeight: '120px',
  }),
  multiValue: (provided) => ({
    ...provided,
    maxWidth: '100%',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    maxWidth: 90,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
};
